import './raid-attack-confirmation.css';

export function RaidAttackConfirmationNotice({ confirmation }) {
  if (!confirmation) return null;
  return <p className="raid-control-attack-confirmation" role="alert">
    <strong>중복 공격 주의</strong>
    <span>{confirmation.names ? confirmation.names + ' 님이' : '다른 멤버가'} 같은 보스를 공격 중입니다. ‘확인’을 누르면 함께 시작하고, ‘대기’를 누르면 현재 상태를 유지합니다.</span>
  </p>;
}
